import React from 'react';

const baseCardStyle = {
  background: '#FFFFFF',
  padding: '12px 16px',
  borderRadius: 8,
  border: '1px solid #DFE1E6',
  boxShadow: '0 1px 2px rgba(9,30,66,0.06)',
  marginBottom: 10,
};

const layoutStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
};

const leftStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  minWidth: 0,
};

const titleStyle = {
  margin: 0,
  fontSize: 17,
  lineHeight: 1.2,
  fontWeight: 700,
  color: '#0052CC',
  letterSpacing: '-0.2px',
};

const subtitleStyle = {
  margin: '3px 0 0',
  fontSize: 12,
  lineHeight: 1.35,
  color: '#5E6C84',
  fontWeight: 400,
};

const actionsStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 8,
  flexWrap: 'wrap',
  marginLeft: 'auto',
};

const iconTileStyle = {
  width: 36,
  height: 36,
  background: '#0C66E4',
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  boxShadow: '0 2px 4px rgba(9,30,66,0.14)',
  flexShrink: 0,
  color: '#FFFFFF',
};

export const evidenceHeaderControlLabelStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: '#172B4D',
  whiteSpace: 'nowrap',
};

export const evidenceHeaderSelectStyle = {
  padding: '6px 10px',
  fontSize: 13,
  border: '1px solid #C1C7D0',
  borderRadius: 6,
  backgroundColor: '#FFFFFF',
  cursor: 'pointer',
  outline: 'none',
  fontWeight: 400,
  color: '#172B4D',
  fontFamily: 'inherit',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
};

export const evidenceHeaderMetaStyle = {
  fontSize: 12,
  color: '#5E6C84',
  fontStyle: 'italic',
  whiteSpace: 'nowrap',
};

const EvidenceHeader = ({
  icon,
  title,
  subtitle,
  actions = null,
  style = null,
  titleColor = '#0052CC',
  iconBackground = '#0C66E4',
}) => {
  return (
    <div style={{ ...baseCardStyle, ...(style || {}) }}>
      <div style={layoutStyle}>
        <div style={leftStyle}>
          <div style={{ ...iconTileStyle, background: iconBackground }}>{icon}</div>
          <div style={{ minWidth: 0 }}>
            <h2 style={{ ...titleStyle, color: titleColor }}>{title}</h2>
            <p style={subtitleStyle}>{subtitle}</p>
          </div>
        </div>
        {actions ? <div style={actionsStyle}>{actions}</div> : null}
      </div>
    </div>
  );
};

export default EvidenceHeader;
